export const API_PRODUCT_DETAILS_SUCCESS = "API_PRODUCT_DETAILS_SUCCESS";
export const API_PRODUCT_DETAILS_ERROR = "API_PRODUCT_DETAILS_ERROR";
export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";